import React from 'react';
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

import { useSwiper } from "swiper/react";

const SwiperButton = (props) => {
    const { t } = useTranslation(["glossary"]);
    const swiper = useSwiper();

    return <button
        type = "button"
        className = {`btn border-0 link-warning rolling-btn rolling-btn-${props.type == "next" ? "end" : "start"} position-absolute ${props.type == "next" ? "end" : "start"}-0 ${props.disabled ? "disabled" : ""}`}
        onClick = { () => { props.type == "next" ? swiper.slideNext() : swiper.slidePrev(); } }
    >
        <i className = {`rolling-btn-icon bi bi-caret-${props.type == "next" ? "right" : "left"}-fill`}></i>
        <span className = 'rolling-btn-text'>{ props.type == "next" ? t("glossary:next") : t("glossary:back") }</span>
    </button>;
};

SwiperButton.propTypes = {
    disabled: PropTypes.bool,
    type: PropTypes.string
};

export default SwiperButton;

